/* Chicore Exotic — shared behaviour */
window.Chicore = (function () {

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  /* ---------- star rating markup ---------- */
  function stars(rating, count, opts) {
    opts = opts || {};
    const pct = (rating / 5) * 100;
    const label = opts.hideCount ? '' :
      `<span>${rating.toFixed(1)}${count != null ? ` (${count})` : ''}</span>`;
    return `<span class="stars" role="img" aria-label="${rating} out of 5 stars${count != null ? `, ${count} reviews` : ''}">
      <span class="stars__glyphs" aria-hidden="true"><span class="stars__fill" style="width:${pct}%"></span></span>
      ${label}
    </span>`;
  }

  /* ---------- mobile navigation ---------- */
  function initNav() {
    const burger = document.querySelector('.burger');
    const nav = document.querySelector('.nav');
    if (!burger || !nav) return;

    function close() {
      document.body.classList.remove('nav-open');
      burger.setAttribute('aria-expanded', 'false');
    }

    burger.addEventListener('click', () => {
      const open = document.body.classList.toggle('nav-open');
      burger.setAttribute('aria-expanded', String(open));
    });
    nav.addEventListener('click', e => { if (e.target.closest('a')) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
    window.addEventListener('resize', () => { if (window.innerWidth >= 1000) close(); });
    document.addEventListener('click', e => {
      if (!document.body.classList.contains('nav-open')) return;
      if (e.target.closest('.nav') || e.target.closest('.burger')) return;
      close();
    });
  }

  /* ---------- hero: staggered clips with pointer parallax ----------
     Base offsets live here so the parallax can add to them rather than
     fight the stylesheet. Desktop and fine pointers only. */
  function initHero(hero) {
    if (!hero) return;

    hero.querySelectorAll('video').forEach(v => v.play().catch(() => {}));

    if (reduced || !finePointer) return;

    const clips = [
      { el: hero.querySelector('.hero__clip--a'), base: -30, depth: 0.50 },
      { el: hero.querySelector('.hero__clip--b'), base:  26, depth: 0.95 },
      { el: hero.querySelector('.hero__clip--c'), base:  -8, depth: 0.35 }
    ].filter(c => c.el);

    let raf = null;

    function paint(e) {
      if (window.innerWidth < 1000) return;
      const r = hero.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        clips.forEach(c => {
          c.el.style.transform =
            `translate3d(${(x * c.depth * 26).toFixed(2)}px,` +
            `${(c.base + y * c.depth * 22).toFixed(2)}px,0)` +
            ` rotateY(${(x * c.depth * -5).toFixed(2)}deg)`;
        });
      });
    }

    function reset() {
      if (raf) cancelAnimationFrame(raf);
      clips.forEach(c => { c.el.style.transform = ''; });
    }

    hero.addEventListener('pointermove', paint);
    hero.addEventListener('pointerleave', reset);
  }

  /* ---------- reels: play muted in view, sound on tap ---------- */
  function initReels(container) {
    if (!container) return;
    const vids = container.querySelectorAll('video');

    if ('IntersectionObserver' in window && !reduced) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(en => {
          const v = en.target;
          if (en.isIntersecting) { v.play().catch(() => {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.4 });
      vids.forEach(v => io.observe(v));
    }

    container.querySelectorAll('.reel__play').forEach(btn => {
      btn.addEventListener('click', () => {
        const v = btn.parentElement.querySelector('video');
        vids.forEach(o => { if (o !== v) o.muted = true; });
        v.muted = !v.muted;
        v.play().catch(() => {});
      });
    });
  }

  /* ---------- seamless ticker ---------- */
  function loopTicker(track) {
    if (track) track.innerHTML += track.innerHTML;
  }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    if (!root) return;
    const stage = root.querySelector('[data-stage]');
    const stageVid = root.querySelector('[data-stage-video]');
    root.querySelectorAll('[data-thumb]').forEach(btn => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('[data-thumb]').forEach(b => b.setAttribute('aria-current', 'false'));
        btn.setAttribute('aria-current', 'true');
        if (btn.dataset.video) {
          stage.hidden = true;
          stageVid.hidden = false;
          stageVid.src = btn.dataset.video;
          stageVid.play().catch(() => {});
        } else {
          stageVid.hidden = true;
          stageVid.pause();
          stage.hidden = false;
          stage.src = btn.dataset.full;
        }
      });
    });
  }

  /* ---------- size picker ---------- */
  function initSizes(root, onChange) {
    if (!root) return;
    root.addEventListener('change', e => {
      if (e.target.name === 'size' && onChange) onChange(e.target.value);
    });
  }

  /* ---------- sticky buy bar (mobile) ---------- */
  function initStickyBuy(bar, watch) {
    if (!bar || !watch || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => bar.classList.toggle('is-up', !en.isIntersecting && en.boundingClientRect.top < 0));
    }, { threshold: 0 });
    io.observe(watch);
  }

  return { stars, initNav, initHero, initReels, loopTicker, initGallery, initSizes, initStickyBuy, reduced };
})();

/* ==========================================================================
   Theme boot — runs on every page
   ========================================================================== */
(function () {
  'use strict';

  function money(cents) {
    var fmt = window.CE_MONEY_FORMAT || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var whole = amount.split('.')[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var dec = amount.split('.')[1];
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + dec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole + ',' + dec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole);
  }

  function initProduct() {
    var pdp = document.querySelector('[data-pdp]');
    if (!pdp) return;

    Chicore.initGallery(pdp.querySelector('[data-gallery]'));

    /* sizes saved out of order get sorted for display */
    pdp.querySelectorAll('[data-sort-numeric="true"] .sizes').forEach(function (wrap) {
      var pairs = [];
      wrap.querySelectorAll('label').forEach(function (label) {
        var input = wrap.querySelector('#' + CSS.escape(label.getAttribute('for')));
        pairs.push({ input: input, label: label, n: parseFloat(label.dataset.value) });
      });
      if (!pairs.length || pairs.some(function (p) { return isNaN(p.n); })) return;
      pairs.sort(function (a, b) { return a.n - b.n; });
      pairs.forEach(function (p) { wrap.appendChild(p.input); wrap.appendChild(p.label); });
    });

    var json = document.querySelector('[data-variant-json]');
    var variants = json ? JSON.parse(json.textContent) : [];
    var idField = pdp.querySelector('[data-variant-id]');
    var priceEl = pdp.querySelector('[data-price]');
    var compareEl = pdp.querySelector('[data-compare]');
    var submit = pdp.querySelector('[data-submit]');
    var submitText = pdp.querySelector('[data-submit-text]');
    var addLabel = submitText ? submitText.textContent.trim() : 'ADD TO BAG';
    var stage = pdp.querySelector('[data-stage]');

    var bundle = document.querySelector('[data-bundle]');
    var mateToggle = document.querySelector('[data-mate-toggle]');
    var mateSelect = document.querySelector('[data-mate-select]');
    var stickyBar = document.querySelector('[data-sticky-buy]');

    function chosen() {
      return Array.prototype.map.call(pdp.querySelectorAll('.opt'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function current() {
      var picked = chosen();
      if (!picked.length) return variants[0];
      return variants.find(function (v) {
        return picked.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function matePrice() {
      if (!bundle) return 0;
      if (mateSelect) {
        var o = mateSelect.selectedOptions[0];
        return o ? parseInt(o.dataset.price, 10) : 0;
      }
      return parseInt(bundle.dataset.matePrice, 10) || 0;
    }

    function paintBundle(variant) {
      if (!bundle || !variant) return;
      var on = !mateToggle || mateToggle.checked;
      var saving = parseInt(bundle.dataset.saving, 10) || 0;
      var live = bundle.dataset.live === 'true';
      var list = variant.price + (on ? matePrice() : 0);
      var pay = (on && live) ? list - saving : list;

      var row = document.querySelector('[data-mate-row]');
      if (row) row.classList.toggle('is-off', !on);
      var waist = document.querySelector('.bundle__waist');
      if (waist) waist.style.display = on ? '' : 'none';

      var base = document.querySelector('[data-bundle-base]');
      if (base) base.textContent = money(variant.price);
      var mOut = document.querySelector('[data-mate-price-out]');
      if (mOut) mOut.textContent = money(matePrice());

      var was = document.querySelector('[data-bundle-was]');
      var now = document.querySelector('[data-bundle-now]');
      if (was) { was.hidden = pay >= list; was.textContent = money(list); }
      if (now) now.textContent = money(pay);

      var badge = document.querySelector('[data-bundle-save]');
      if (badge) {
        badge.textContent = (on && live) ? 'SAVE ' + money(saving) : 'BUNDLE';
        badge.style.background = (on && live) ? 'var(--tan)' : 'transparent';
        badge.style.color = (on && live) ? 'var(--hide)' : 'var(--ash)';
      }
      var addBtn = document.querySelector('[data-bundle-add]');
      if (addBtn) addBtn.textContent = on ? 'ADD BOTH TO BAG — ' + money(pay) : 'ADD TO BAG — ' + money(pay);
    }

    function paintSticky(variant) {
      if (!stickyBar || !variant) return;
      var priceOut = stickyBar.querySelector('[data-sticky-price]');
      var noteOut = stickyBar.querySelector('[data-sticky-note]');
      if (priceOut) priceOut.textContent = money(variant.price);
      if (noteOut) {
        var picked = chosen().filter(Boolean);
        noteOut.textContent = picked.length ? picked.join(' / ') : 'Choose a size';
      }
    }

    function update() {
      chosen().forEach(function (val, i) {
        var out = pdp.querySelector('[data-selected-for="' + i + '"]');
        if (out && val) out.textContent = val;
      });

      var match = current();
      if (!match) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = 'Unavailable';
        return;
      }

      if (idField) idField.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (compareEl) {
        var sale = match.compare_at_price && match.compare_at_price > match.price;
        compareEl.hidden = !sale;
        if (sale) compareEl.textContent = money(match.compare_at_price);
      }
      if (submit) submit.disabled = !match.available;
      if (submitText) submitText.textContent = match.available ? addLabel : 'SOLD OUT';
      if (match.featured_image && stage) stage.src = match.featured_image.src;

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }

      paintBundle(match);
      paintSticky(match);
    }

    pdp.querySelectorAll('.opt input[type=radio]').forEach(function (i) {
      i.addEventListener('change', update);
    });

    var guideBtn = pdp.querySelector('[data-open-guide]');
    if (guideBtn) {
      guideBtn.addEventListener('click', function () {
        var g = document.getElementById('size-guide');
        if (!g) return;
        g.open = true;
        g.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }

    if (mateToggle) mateToggle.addEventListener('change', function () { paintBundle(current()); });
    if (mateSelect) mateSelect.addEventListener('change', function () { paintBundle(current()); });

    var jump = document.querySelector('[data-jump-bundle]');
    if (jump) {
      jump.addEventListener('click', function () {
        if (mateToggle) mateToggle.checked = true;
        paintBundle(current());
        bundle.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }

    var bundleAdd = document.querySelector('[data-bundle-add]');
    if (bundleAdd) {
      bundleAdd.addEventListener('click', function () {
        var match = current();
        if (!match) return;
        var items = [{ id: match.id, quantity: 1 }];
        if (mateToggle && mateToggle.checked) {
          var mateId = mateSelect ? mateSelect.value : bundle.dataset.mateVariant;
          if (mateId) items.push({ id: parseInt(mateId, 10), quantity: 1 });
        }
        bundleAdd.disabled = true;
        bundleAdd.textContent = 'ADDING…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            var code = bundle.dataset.code;
            var live = bundle.dataset.live === 'true';
            if (code && live && mateToggle && mateToggle.checked) {
              window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () {
            bundleAdd.disabled = false;
            bundleAdd.textContent = 'Could not add — try again';
          });
      });
    }

    if (stickyBar) {
      var watch = pdp.querySelector('[data-submit]') || pdp.querySelector('.pdp__buy');
      Chicore.initStickyBuy(stickyBar, watch);
    }

    update();
  }

  function initReviews() {
    var section = document.getElementById('reviews');
    if (!section) return;

    // filter chips
    var chips = section.querySelector('[data-rev-filters]');
    if (chips) {
      chips.addEventListener('click', function (e) {
        var btn = e.target.closest('.chip');
        if (!btn) return;
        chips.querySelectorAll('.chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var f = btn.dataset.filter;
        section.querySelectorAll('.rev__item').forEach(function (item) {
          var tags = (item.dataset.tags || '').split(' ');
          item.hidden = f !== 'all' && tags.indexOf(f) === -1;
        });
      });
    }

    // photo lightbox
    var modal = section.querySelector('[data-lightbox-modal]');
    var img = section.querySelector('[data-lightbox-img]');
    if (!modal || !img) return;

    function close() { modal.classList.remove('is-open'); img.src = ''; }

    section.addEventListener('click', function (e) {
      var shot = e.target.closest('[data-lightbox]');
      if (!shot) return;
      img.src = shot.dataset.lightbox;
      img.alt = shot.alt || '';
      modal.classList.add('is-open');
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-lightbox-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- free gift offer strip ---------- */
  function initOffer() {
    var btn = document.querySelector('[data-offer-claim]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var pdp = document.querySelector('[data-pdp]');
      var idField = pdp ? pdp.querySelector('[data-variant-id]') : null;
      var mainId = idField ? parseInt(idField.value, 10) : null;
      var giftId = parseInt(btn.dataset.giftVariant, 10);
      if (!mainId || !giftId) return;

      var picked = document.querySelector('.opt input[type=radio]:checked');
      var needsSize = document.querySelector('.opt');
      if (needsSize && !picked) {
        document.querySelector('.sizes').scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }

      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = 'ADDING…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: mainId, quantity: 1 }, { id: giftId, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          var code = btn.dataset.offerCode;
          window.location.href = code
            ? '/discount/' + encodeURIComponent(code) + '?redirect=/cart'
            : '/cart';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  }

  /* ---------- exit intent offer ---------- */
  function initExitOffer() {
    var pop = document.querySelector('[data-exit-offer]');
    if (!pop) return;

    var KEY = 'ce_exit_offer_seen';
    try { if (sessionStorage.getItem(KEY)) return; } catch (err) { /* private mode */ }

    if (pop.dataset.cartOnly === 'true' && !/\/cart/.test(window.location.pathname)) return;

    var armed = false;
    var open = false;
    var lastY = window.scrollY;
    var delay = parseInt(pop.dataset.armDelay, 10) || 0;

    setTimeout(function () { armed = true; }, delay);

    function show() {
      if (!armed || open) return;
      open = true;
      pop.hidden = false;
      try { sessionStorage.setItem(KEY, '1'); } catch (err) { /* ignore */ }
      var close = pop.querySelector('[data-exit-close]');
      if (close) close.focus();
    }

    function hide() {
      open = false;
      pop.hidden = true;
    }

    // desktop: pointer leaves through the top of the window
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 4) return;
      show();
    });

    // mobile: a fast flick back to the top reads as leaving
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (lastY - y > 220 && y < 260) show();
      lastY = y;
    }, { passive: true });

    pop.querySelectorAll('[data-exit-close]').forEach(function (el) {
      el.addEventListener('click', hide);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) hide();
    });

    var copy = pop.querySelector('[data-exit-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var code = pop.querySelector('[data-exit-code]').textContent.trim();
        var done = function () {
          copy.textContent = 'COPIED';
          setTimeout(function () { copy.textContent = 'COPY'; }, 2000);
        };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          done();
        }
      });
    }
  }

  /* ---------- exit intent offer ---------- */
  function initExitOffer() {
    var pop = document.querySelector('[data-exit-offer]');
    if (!pop) return;

    var key = 'ce_exit_' + (pop.dataset.code || 'offer');
    var days = parseInt(pop.dataset.days, 10) || 7;
    var delay = (parseInt(pop.dataset.delay, 10) || 0) * 1000;
    var useReturn = pop.dataset.returnTrigger === 'true';

    // already seen it recently? stay out of the way.
    try {
      var until = window.localStorage.getItem(key);
      if (until && Date.now() < parseInt(until, 10)) return;
    } catch (e) {}

    var armed = delay === 0;
    var done = false;
    if (!armed) window.setTimeout(function () { armed = true; }, delay);

    function remember() {
      try {
        window.localStorage.setItem(key, String(Date.now() + days * 86400000));
      } catch (e) {}
    }

    function open() {
      if (done || !armed) return;
      done = true;
      pop.classList.add('is-open');
      remember();
      var close = pop.querySelector('[data-exit-close]');
      if (close) close.focus();
    }

    function close() { pop.classList.remove('is-open'); }

    // desktop: cursor leaves through the top of the window
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.toElement) return;
      if (e.clientY > 0) return;
      open();
    });

    // mobile: they switched app or tab, then came back
    if (useReturn) {
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') open();
      });
    }

    pop.querySelectorAll('[data-exit-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop.classList.contains('is-open')) close();
    });

    var copy = pop.querySelector('[data-exit-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var code = pop.dataset.code || '';
        var label = copy.textContent;
        function ok() {
          copy.textContent = 'COPIED';
          window.setTimeout(function () { copy.textContent = label; }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(ok).catch(function () {});
        } else {
          var t = document.createElement('textarea');
          t.value = code;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); ok(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    }
  }

  /* ---------- offer strip: add the gift and apply the code ---------- */
  function initOfferBar() {
    var bar = document.querySelector('[data-offer-bar]');
    if (!bar || bar.dataset.wired !== 'true') return;
    var btn = bar.querySelector('[data-offer-add]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var giftId = parseInt(bar.dataset.giftVariant, 10);
      var code = bar.dataset.code;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'ADDING…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: giftId, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  }

  /* ---------- recovery offer ----------
     Shopify's checkout runs on Shopify's own domain, so no theme code can
     run there. This fires on the store pages instead, once per session. */
  function initExitOffer() {
    var modal = document.querySelector('[data-exit-offer]');
    if (!modal) return;

    var scope = modal.dataset.scope || 'cart';
    var path = window.location.pathname;
    var onCart = path.indexOf('/cart') === 0;
    var onProduct = path.indexOf('/products/') !== -1;
    if (scope === 'cart' && !onCart) return;
    if (scope === 'cart_product' && !onCart && !onProduct) return;

    var KEY = 'ce_recovery_seen';
    try { if (sessionStorage.getItem(KEY)) return; } catch (err) { /* private mode */ }

    var shown = false;
    function open() {
      if (shown) return;
      shown = true;
      try { sessionStorage.setItem(KEY, '1'); } catch (err) {}
      modal.classList.add('is-open');
      var close = modal.querySelector('[data-exit-close]');
      if (close) close.focus();
    }
    function hide() { modal.classList.remove('is-open'); }

    // desktop: pointer leaves through the top of the window
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 8) return;
      open();
    });

    // touch: a fast flick back to the top, which is how people reach for
    // the address bar or the back gesture. No back-button hijacking.
    var lastY = window.scrollY;
    var lastT = Date.now();
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      var t = Date.now();
      var dt = t - lastT;
      if (dt > 0 && lastY - y > 220 && dt < 320 && y < 420) open();
      lastY = y;
      lastT = t;
    }, { passive: true });

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-exit-close]')) hide();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });

    var copy = modal.querySelector('[data-exit-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var code = modal.dataset.code;
        var done = function () { copy.textContent = 'COPIED'; };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done).catch(done);
        else done();
      });
    }

    var apply = modal.querySelector('[data-exit-apply]');
    if (apply) {
      apply.addEventListener('click', function () {
        window.location.href = '/discount/' + encodeURIComponent(modal.dataset.code) + '?redirect=/checkout';
      });
    }
  }

  /* ---------- exit-intent offer ----------
     Cannot run on checkout (Shopify's own domain), so this watches for a
     pointer leaving the top of the window on desktop, or a fast upward flick
     on mobile. Shown once, then suppressed for the configured number of days. */
  function initExitOffer() {
    var root = document.querySelector('[data-exit-offer]');
    if (!root) return;

    var KEY = 'ce_exit_offer_seen';
    var repeatDays = parseInt(root.dataset.repeat, 10) || 7;
    var minMs = (parseInt(root.dataset.delay, 10) || 0) * 1000;
    var requireCart = root.dataset.requireCart === 'true';
    var cartCount = parseInt(root.dataset.cartCount, 10) || 0;

    if (requireCart && cartCount === 0) return;

    try {
      var seen = parseInt(window.localStorage.getItem(KEY), 10);
      if (seen && Date.now() - seen < repeatDays * 864e5) return;
    } catch (err) { /* private mode: just carry on */ }

    var armedAt = Date.now();
    var done = false;
    var panel = root.querySelector('.exitoffer__panel');
    var lastY = window.scrollY;
    var lastT = Date.now();

    function open() {
      if (done || Date.now() - armedAt < minMs) return;
      done = true;
      root.classList.add('is-open');
      try { window.localStorage.setItem(KEY, String(Date.now())); } catch (err) {}
      var close = root.querySelector('[data-exit-close]');
      if (close) close.focus();
      detach();
    }

    function close() {
      root.classList.remove('is-open');
    }

    function onMouseOut(e) {
      if (e.clientY <= 0 && !e.relatedTarget) open();
    }

    function onScroll() {
      var y = window.scrollY;
      var t = Date.now();
      var dt = t - lastT;
      if (dt > 0) {
        var v = (lastY - y) / dt;            // positive = scrolling up
        if (v > 1.6 && y < 220) open();      // fast flick back to the top
      }
      lastY = y;
      lastT = t;
    }

    function detach() {
      document.removeEventListener('mouseout', onMouseOut);
      window.removeEventListener('scroll', onScroll);
    }

    if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.addEventListener('mouseout', onMouseOut);
    } else {
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    root.addEventListener('click', function (e) {
      if (e.target === root || e.target.closest('[data-exit-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
    if (panel) panel.addEventListener('click', function (e) { e.stopPropagation(); });

    var copy = root.querySelector('[data-exit-copy]');
    var codeEl = root.querySelector('[data-exit-code]');
    if (copy && codeEl) {
      copy.addEventListener('click', function () {
        var code = codeEl.textContent.trim();
        var done2 = function () {
          copy.textContent = 'COPIED';
          copy.classList.add('is-copied');
          setTimeout(function () { copy.textContent = 'COPY'; copy.classList.remove('is-copied'); }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done2).catch(function () {});
        } else {
          var t = document.createElement('textarea');
          t.value = code;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); done2(); } catch (err) {}
          document.body.removeChild(t);
        }
      });
    }
  }

  function boot() {
    Chicore.initNav();
    Chicore.initHero(document.querySelector('[data-hero]'));
    document.querySelectorAll('[data-reels]').forEach(function (r) { Chicore.initReels(r); });
    document.querySelectorAll('[data-ticker-track]').forEach(function (t) { Chicore.loopTicker(t); });
    initProduct();
    initReviews();
    initOffer();
    initExitOffer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
